import axios from "axios";

type SpotPermissionsApiResponse = {
    permissions: {
        view: boolean,
    };
};

export type SpotPermissions = {
    view: boolean,
};

export async function getSpotPermissions(id: number): Promise<SpotPermissions> {
    const { data: { permissions } } = await axios.get<SpotPermissionsApiResponse>(
        `${window.location.origin}/api/map/spots/${id}/permissions`,
    );
    return permissions;
};
